/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Status_ConnectedInputs */



/**
* | output |
* | --- |
* | "Connected" |
*
* @param {Live_Caption_Status_ConnectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_status_connected = /** @type {((inputs?: Live_Caption_Status_ConnectedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Status_ConnectedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Connecté")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verbunden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Collegato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подключено")
	if (locale === "es") return /** @type {LocalizedString} */ ("Conectado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已连接")
	if (locale === "ja") return /** @type {LocalizedString} */ ("接続済み")
	if (locale === "hi") return /** @type {LocalizedString} */ ("जुड़े हुए")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Conectado")
	return /** @type {LocalizedString} */ ("Connected")
});